import React, { useEffect, useState } from "react";
import Button from "../../../components/button";

// redux
import { mapDispatchProps, mapStateToProps } from "../../../store/store";
import { connect } from "react-redux";
import TextInputField from "../../../components/textInput";
import Select from "../../../components/select";
import Checkbox from "../../../components/checkbox";
import API from "../../../api";
import { RefreshCw, Trash, PlusSquare } from "react-feather";
import Swal from "sweetalert2";
import { ChromePicker } from "react-color";

import UploadableImages from "../../../libraries/uploadableImages";
import Builder from "./builder";
import { useLanguage } from '@languages/index';


interface Props {
  disabled?: boolean;
  onCreate: any;

  auth?: any;
  showModal?: any;
  closeModal?: any;
}

const BsProductUploader = (props: Props) => {
  const language = useLanguage();   
  const languageTexts = { ...language.common, ...language.pages.sns };

  const [newProdUplImg, setNewProdUplImg] = useState(new UploadableImages( 1, []));
  const [newProdName  , setNewProdName  ] = useState('');
  const [newProdUrl   , setNewProdUrl   ] = useState('');
  const [newProdColor , setNewProdColor ] = useState('');
  const [newProdSize  , setNewProdSize  ] = useState('');


  newProdUplImg.callUseThings();


  return (
      <div className="flex flex-col items-center">
        {newProdUplImg.build(languageTexts.uploader_text_1, props.disabled)}

        <div style={{height:'30px'}}/>
        {Builder.buildTextInput(languageTexts.product_name, [newProdName, setNewProdName], props.disabled)}

        <div style={{height:'10px'}}/>
        {Builder.buildTextInput(languageTexts.uploader_text_3, [newProdUrl, setNewProdUrl], props.disabled)}

        <div style={{height:'10px'}}/>
        {Builder.buildTextInput(languageTexts.uploader_text_4, [newProdColor, setNewProdColor], props.disabled)}

        <div style={{height:'10px'}}/>
        {Builder.buildTextInput(languageTexts.uploader_text_5, [newProdSize, setNewProdSize], props.disabled)}

        <div style={{height:'30px'}}/>
        <Button
          bordered
          borderColor={"#E8E8E8"}
          text={languageTexts.uploader_text_6}
          onClick={async () => {
            if (props.disabled)
              return;

            /// validate
            const validateErros = [];
            if (newProdUplImg.size() <= 0)
              validateErros.push(languageTexts.uploader_text_7);
            if (newProdName.trim().length <= 0)
              validateErros.push(languageTexts.uploader_text_8);
            if (newProdUrl.trim().length <= 0)
              validateErros.push(languageTexts.uploader_text_9);
            if (newProdColor.trim().length <= 0)
              validateErros.push(languageTexts.uploader_text_10);
            if (newProdSize.trim().length <= 0)
              validateErros.push(languageTexts.uploader_text_11);
            if (validateErros.length > 0) {
              return props.showModal({
                hideCloseButton: true,
                text: validateErros.join('\n'),
              });
            }


            /// block screen
            props.showModal({
              hideCloseButton: true,
              hideConfirmButton: true,
              text: languageTexts.uploader_text_12,
            });


            /// upload
            try {
              // upload images
              const uploadedImgUrls = await newProdUplImg.upload(props.auth.token);

              // create
              const res = await API.BrandSns.createBsProduct({
                  brandToken: props.auth.token,
                  productId : null,
                  name      : newProdName.trim(),
                  colorName : newProdColor.trim(),
                  sizeName  : newProdSize.trim(),
                  url       : newProdUrl.trim(),
                  imageUrl  : uploadedImgUrls[0],
              });
              console.log(res);

              // add product
              const prd = res.data.result;
              prd.bsProductId = prd.id;
              props.onCreate(prd);

              // reset
              setNewProdUplImg(new UploadableImages( 1, []));
              setNewProdName  ('');
              setNewProdUrl   ('');
              setNewProdColor ('');
              setNewProdSize  ('');

            }catch (error) {
              props.showModal({
                hideCloseButton: true,
                text: languageTexts.uploader_text_13,
              });
              throw error;
            }


            /// close block-screen-modal
            props.closeModal();
          }}
        />
      </div>
  );
}

export default connect(mapStateToProps, mapDispatchProps)(BsProductUploader);




